var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCf9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(-860 -1365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    transform: "translate(860 1365)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "report_1_",
    "data-name": "report (1)",
    transform: "translate(855.173 1368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M37.235,70.819V73.66H8.827V35.31H37.235V70.819Z",
    transform: "translate(0 -32.469)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M133.528,2.841V4.971a.71.71,0,0,1-.71.71H124.3a.71.71,0,0,1-.71-.71V.71A.71.71,0,0,1,124.3,0h8.522a.71.71,0,0,1,.71.71Z",
    transform: "translate(-105.526)",
    fill: "#8c6239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M278.381,260.687a9.233,9.233,0,1,0,12.6,12.271l-8.251-4.125Z",
    transform: "translate(-243.36 -239.714)",
    fill: "#06aae9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M347.574,253.623a9.232,9.232,0,0,0-13.158-5.391l4.344,8.145Z",
    transform: "translate(-299.395 -227.259)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M397.228,327.7l-8.814,2.754,8.251,4.125a9.205,9.205,0,0,0,.563-6.88Z",
    transform: "translate(-349.049 -301.334)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M107.606,109.6a2.118,2.118,0,0,0-1.675-.828v-2.841a4.958,4.958,0,0,1,3.92,1.922Z",
    transform: "translate(-89.292 -97.409)",
    fill: "#f8cf26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M126.746,131.565a2.106,2.106,0,0,1,.456,1.3h2.841a4.95,4.95,0,0,0-1.051-3.05Z",
    transform: "translate(-108.432 -119.374)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M58,109.667a2.125,2.125,0,0,1,1.73-.895v-2.841a4.959,4.959,0,0,0-4.042,2.084Z",
    transform: "translate(-43.096 -97.409)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M47.379,133.491a2.131,2.131,0,1,0,3.861,1.236h2.841a4.971,4.971,0,1,1-9.013-2.887Z",
    transform: "translate(-32.47 -121.233)",
    fill: "#06aae9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(25.161 8.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M211.862,105.931h9.232v1.42h-9.232Z",
    transform: "translate(-211.862 -105.931)",
    fill: "#29485a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M211.862,141.241h9.232v1.42h-9.232Z",
    transform: "translate(-211.862 -138.4)",
    fill: "#29485a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M211.862,176.552h9.232v1.42h-9.232Z",
    transform: "translate(-211.862 -170.87)",
    fill: "#29485a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M211.862,211.862h4.971v1.42h-4.971Z",
    transform: "translate(-211.862 -203.34)",
    fill: "#29485a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M44.138,432.552h2.131V436.1H44.138Z",
    transform: "translate(-32.47 -397.753)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(15.929 24.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M97.1,397.241h2.131v6.392H97.1Z",
    transform: "translate(-97.103 -390.139)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M150.069,353.1H152.2v9.943h-2.131Z",
    transform: "translate(-145.808 -349.552)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M203.034,308.966h2.131V322.46h-2.131Z",
    transform: "translate(-194.512 -308.966)",
    fill: "#0071bc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(10.958 20.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M35.31,256h5.682v1.42H35.31Z",
    transform: "translate(-35.31 -256)",
    fill: "#29485a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M35.31,282.483h5.682v1.42H35.31Z",
    transform: "translate(-35.31 -280.352)",
    fill: "#29485a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M35.31,308.966h2.841v1.42H35.31Z",
    transform: "translate(-35.31 -304.705)",
    fill: "#29485a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf9);
export default __webpack_public_path__ + "static/media/cf9.8147e308586983fb3770a6d93512eae7.svg";
export { ForwardRef as ReactComponent };